// tabs当前选中
export const BROKER_ACTIVE_NAME = 'BROKER_ACTIVE_NAME'
export const SET_BROKER_ACTIVE_NAME = 'SET_BROKER_ACTIVE_NAME'
export const BROKER_FRONT_APPLY_STATE = 'BROKER_FRONT_APPLY_STATE'
export const BROKER_PAGE_CURRENT = 'BROKER_PAGE_CURRENT'
export const BROKER_LOAN_LIST_DATA = 'BROKER_LOAN_LIST_DATA'
export const BROKER_PAGE_COUNT = 'BROKER_PAGE_COUNT'

export const SET_BROKER_LOAN_LIST_DATA = 'SET_BROKER_LOAN_LIST_DATA'
export const SET_BROKER_PAGE_CURRENT = 'SET_BROKER_PAGE_CURRENT'
export const SET_BROKER_FRONT_APPLY_STATE = 'SET_BROKER_FRONT_APPLY_STATE'
export const SET_BROKER_PAGE_COUNT = 'SET_BROKER_PAGE_COUNT'

export const GET_BROKER_LOAN_LIST_DATA = 'GET_BROKER_LOAN_LIST_DATA'
export const GET_BROKER_PAGE_CURRENT = 'GET_BROKER_PAGE_CURRENT'

export const DELETE_BROKER_LOAN_ITEM_FRONT_APPLY = 'DELETE_BROKER_LOAN_ITEM_FRONT_APPLY'



// WEBPACK FOOTER //
// ./src/vuex/types/brokerCenter/applicationList.js